import { DatePicker} from 'antd';
import {Dayjs} from 'dayjs';

interface Props {
    value: Dayjs;
    onChange?: (value: Dayjs) => void;
}


export const MyDatePicker = ({value, onChange}: Props) => (
    <DatePicker value={value} onChange={(date) => date && onChange?.(date)} format={'DD.MM.YYYY'}
                variant={'filled'} allowClear={false}/>
)
